/* CEN: model-code search (Oct 2026).
   Shopify's search only matches whole model codes (SPH-DA360DAB) - partial codes like
   "sph-da3", "da360" or "dmx80" return nothing. This loads a small product index the first
   time a search box is focused, matches partial codes anywhere in a product's model codes,
   SKUs, barcodes and MPN, and puts those products at the top of the predictive results.
   Index: /collections/all?view=cen-search-index  Cards: /products/<handle>?view=cen-card */
(function () {
  if (window.cenCodeSearch) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var STORE_KEY = 'cenCodeIdx_v1';
  var TTL = 30 * 60 * 1000;
  var MAX_HITS = 8;
  var idx = null, loading = null, cards = new Map();

  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

  // Model-code-like token: letters AND digits (A229, DA360DAB) or hyphenated (SPH-DA360DAB),
  // but not a plain measurement (12V, 2000W, 128GB, 6.8").
  // Number + unit only (12V, 2000W, 128GB, 4K, 6.8", 120fps) - NOT codes like 8DSP or 77DAB.
  var MEASURE = /^\d+([.,]\d+)?(v|w|a|ah|mah|wh|kwh|kw|mm|cm|m|in|inch|gb|tb|hz|khz|k|p|fps|ohm|ohms|awg|"|')$/i;

  function isCode(tok) {
    if (tok.length < 3) return false;
    if (MEASURE.test(tok)) return false;
    var hasL = /[a-z]/i.test(tok), hasD = /\d/.test(tok);
    return (hasL && hasD) || (hasL && /[a-z0-9]-[a-z0-9]/i.test(tok));
  }

  // Every code plus its tails from each hyphen, so "da360" finds SPH-DA360DAB.
  function addCode(set, raw) {
    var parts = raw.split(/[-–._\/]+/).filter(Boolean);
    for (var i = 0; i < parts.length; i++) {
      if (i > 0 && MEASURE.test(parts.slice(i).join(''))) continue; // "6V-12V" adds no "12v" tail
      var n = norm(parts.slice(i).join(''));
      if (n.length >= (i === 0 ? 2 : 3)) set.add(n);
    }
  }

  function build(rows) {
    return rows.map(function (r) {
      var title = r[1] || '', codes = new Set(), words = [];
      title.split(/[\s(),]+/).forEach(function (tok) {
        tok = tok.replace(/^[^a-z0-9]+|[^a-z0-9]+$/gi, '');
        if (!tok) return;
        words.push(norm(tok));
        if (isCode(tok)) addCode(codes, tok);
      });
      // SKUs / barcodes / MPN / model: matched from the start only (a barcode containing "8021" is noise)
      var ids = new Set();
      String(r[3] || '').split('|').forEach(function (x) { x = x.trim(); if (x.length >= 3) addCode(ids, x); });
      return { h: r[0], t: title, a: !!r[2], c: Array.from(codes), k: Array.from(ids), w: words };
    });
  }

  function fetchPage(n) {
    return fetch(ROOT + 'collections/all?view=cen-search-index&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }

  function load() {
    if (idx) return Promise.resolve(idx);
    if (loading) return loading;
    try {
      var s = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (s && Date.now() - s.at < TTL && s.rows) { idx = build(s.rows); return Promise.resolve(idx); }
    } catch (e) {}
    loading = fetchPage(1).then(function (first) {
      var jobs = [];
      for (var p = 2; p <= (first.p || 1); p++) jobs.push(fetchPage(p));
      return Promise.all(jobs).then(function (rest) {
        var rows = first.i.slice();
        rest.forEach(function (pg) { rows = rows.concat(pg.i); });
        try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ at: Date.now(), rows: rows })); } catch (e) {}
        idx = build(rows);
        return idx;
      });
    }).catch(function () { loading = null; return null; });
    return loading;
  }

  function search(term) {
    if (!idx) return [];
    var q = norm(term);
    if (q.length < 3 || MEASURE.test(String(term).trim())) return []; // "12v", "2000w": leave to Shopify
    var words = String(term).split(/\s+/).map(norm).filter(function (w) { return w.length >= 2; });
    var hasDigit = /\d/.test(q), out = [];
    idx.forEach(function (p) {
      var s = 0;
      for (var i = 0; i < p.c.length; i++) {
        var c = p.c[i];
        if (c === q) { s = 100; break; }
        if (c.indexOf(q) === 0) s = Math.max(s, 80 - Math.min(20, c.length - q.length));
        else if (hasDigit && q.length >= 4 && c.indexOf(q) > 0) s = Math.max(s, 40);
      }
      if (s < 100) for (var j = 0; j < p.k.length; j++) {
        var k = p.k[j];
        if (k === q) { s = 100; break; }
        if (k.indexOf(q) === 0) s = Math.max(s, 70 - Math.min(20, k.length - q.length));
      }
      // "pioneer sph-da3" / "viofo a2": every word must match, at least one against a code
      if (!s && words.length > 1) {
        var codeHit = false, all = words.every(function (w) {
          var inCode = p.c.some(function (c) { return c.indexOf(w) === 0; }) || p.k.some(function (k) { return k.indexOf(w) === 0; });
          if (inCode) codeHit = true;
          return inCode || p.w.some(function (x) { return x.indexOf(w) === 0; });
        });
        if (all && codeHit) s = 30;
      }
      if (s) out.push({ h: p.h, s: s, a: p.a, l: p.t.length });
    });
    out.sort(function (x, y) { return (y.a - x.a) || (y.s - x.s) || (x.l - y.l); });
    return out.slice(0, MAX_HITS);
  }

  function card(handle) {
    if (cards.has(handle)) return cards.get(handle);
    var p = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?view=cen-card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { return t.indexOf('product-card-small') > -1 ? t.trim() : ''; })
      .catch(function () { return ''; });
    cards.set(handle, p);
    return p;
  }

  // Puts code matches at the top of the theme's predictive-search markup (products tab).
  function merge(markup, term) {
    return load().then(function () {
      var hits = search(term);
      if (!hits.length) return markup;
      return Promise.all(hits.map(function (h) { return card(h.h); })).then(function (html) {
        html = html.filter(Boolean);
        if (!html.length) return markup;
        var doc = new DOMParser().parseFromString('<div id="cen-r">' + markup + '</div>', 'text/html');
        var r = doc.getElementById('cen-r');
        var tabs = r.querySelector('side-panel-content-tabs');
        var inner = r.querySelector('.side-panel-content--inner');
        if (!tabs || !inner) return markup;
        var panels = Array.prototype.slice.call(inner.children).filter(function (el) { return el.classList.contains('side-panel-content--tab-panel'); });
        var prod = panels.filter(function (el) { return el.querySelector('product-card-small'); })[0];
        if (!prod) {
          tabs.querySelectorAll('button').forEach(function (b) { b.classList.remove('tab-active'); });
          panels.forEach(function (el) { el.classList.remove('tab-active'); });
          var btn = doc.createElement('button');
          btn.type = 'button'; btn.className = 'tab-active'; btn.textContent = 'Products';
          tabs.insertBefore(btn, tabs.firstChild);
          prod = doc.createElement('div');
          prod.className = 'side-panel-content--tab-panel tab-active';
          inner.insertBefore(prod, inner.firstChild);
        }
        var have = new Set(hits.map(function (h) { return h.h; }));
        prod.querySelectorAll('product-card-small').forEach(function (el) { if (have.has(el.getAttribute('data-product-handle'))) el.remove(); });
        prod.insertAdjacentHTML('afterbegin', html.join(''));
        return r.innerHTML;
      });
    });
  }

  // Enter on an exact model code / SKU goes straight to that product.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/search') === -1 || !idx) return;
    var input = f.querySelector('input[name="q"]');
    var hits = input ? search(input.value) : [];
    if (hits.length && hits[0].s === 100 && !(hits[1] && hits[1].s === 100)) {
      e.preventDefault();
      window.location.href = ROOT + 'products/' + hits[0].h;
    }
  }, true);

  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[name="q"], .search-field')) load();
  });

  window.cenCodeSearch = { load: load, search: search, merge: merge };
})();
